/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { UpdateCloudResourceConfigurationRequestCdcBackup } from '../models/UpdateCloudResourceConfigurationRequestCdcBackup';
import { UpdateCloudResourceConfigurationRequestInventoryBackup } from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup';

export class UpdateCloudResourceConfigurationRequest {
  'cdcBackup'?: UpdateCloudResourceConfigurationRequestCdcBackup | null;
  'inventoryBackup'?: UpdateCloudResourceConfigurationRequestInventoryBackup | null;
  /**
  * The number of partitions to set for the DynamoDB resource
  */
  'setDynamoDbPartitions'?: number | null;
  /**
  * Set the bin duration in minutes for the DynamoDB resource
  */
  'setDynamoDbBinDurationMinutes'?: number | null;
  /**
  * The number of items per partition for the DynamoDB resource
  */
  'setDynamoDbPartitionItems'?: number | null;
  /**
  * The number of processors per partition for storage layer backup (default 8)
  */
  'setStorageLayerBackupProcessorsPerPartition'?: number | null;
  /**
  * The maximum number of nodes for storage layer backup (default 100)
  */
  'setStorageLayerBackupMaxNodes'?: number | null;
  /**
  * Override the partition scheme for storage layer operations
  */
  'setStorageLayerPartitionSchemeOverride'?: string | null;
  /**
  * The maximum number of days allowed between full backups (vs CDC backups)
  */
  'setStorageLayerMaxFullBackupInterval'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cdcBackup",
      "baseName": "cdcBackup",
      "type": "UpdateCloudResourceConfigurationRequestCdcBackup",
      "format": ""
    },
    {
      "name": "inventoryBackup",
      "baseName": "inventoryBackup",
      "type": "UpdateCloudResourceConfigurationRequestInventoryBackup",
      "format": ""
    },
    {
      "name": "setDynamoDbPartitions",
      "baseName": "setDynamoDbPartitions",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "setDynamoDbBinDurationMinutes",
      "baseName": "setDynamoDbBinDurationMinutes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "setDynamoDbPartitionItems",
      "baseName": "setDynamoDbPartitionItems",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "setStorageLayerBackupProcessorsPerPartition",
      "baseName": "setStorageLayerBackupProcessorsPerPartition",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "setStorageLayerBackupMaxNodes",
      "baseName": "setStorageLayerBackupMaxNodes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "setStorageLayerPartitionSchemeOverride",
      "baseName": "setStorageLayerPartitionSchemeOverride",
      "type": "string",
      "format": ""
    },
    {
      "name": "setStorageLayerMaxFullBackupInterval",
      "baseName": "setStorageLayerMaxFullBackupInterval",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return UpdateCloudResourceConfigurationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

